import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import './Pondy.css';

import {
  FaMapMarkerAlt,
  FaPhone,
  FaArrowRight,
  FaCheckCircle,
  FaGlobe,
  FaWhatsapp,
  FaClock,
  FaStar,
  FaUserMd,
  FaAward,
  FaHeartbeat,
  FaRegLightbulb,
  FaShieldAlt,
  FaCertificate,
  FaUserCheck,
  FaCoins,
  FaDirections,
} from "react-icons/fa";
import { GiMedicalPack } from "react-icons/gi";
import {
  MdOutlineHealthAndSafety,
  MdSupportAgent,
} from "react-icons/md";
import { } from "react-icons/ri";
import { } from "react-icons/bi";
import tambaramskin from "../../../assets/images/tambaramskinicon.png";
import tambaramhair from "../../../assets/images/tambaramhairicon1.png";
import tambaramleaf from "../../../assets/images/tambaramleaf.jpg";
import tambarambanner3 from "../../../assets/images/tambarambanner4.png";
// Import combined Before-After images
import img1 from "../../../assets/images/autoscroll1.jpg";
import img2 from "../../../assets/images/autoscroll2.jpg";
import img3 from "../../../assets/images/autoscroll3.jpg";
import img4 from "../../../assets/images/autoscroll4.jpg";
import img5 from "../../../assets/images/autoscroll5.jpg";
import img6 from "../../../assets/images/autoscroll6.jpg";
import img7 from "../../../assets/images/autoscroll7.jpg";
import img8 from "../../../assets/images/autoscroll8.jpg";
import img9 from "../../../assets/images/autoscroll9.jpg";
import img10 from "../../../assets/images/autoscroll10.jpg";
import img11 from "../../../assets/images/autoscrollskin1.png";
import img12 from "../../../assets/images/autoscrollskin2.png";
import img13 from "../../../assets/images/autoscrollskin3.png";
import img14 from "../../../assets/images/autoscrollskin4.png";
import img15 from "../../../assets/images/autoscrollskin5.png";
import img16 from "../../../assets/images/autoscrollskin6.png";
import img17 from "../../../assets/images/autoscrollskin7.png";
import img18 from "../../../assets/images/autoscrollskin8.png";
import img19 from "../../../assets/images/autoscrollskin9.png";
import img20 from "../../../assets/images/autoscrollskin10.png";

import chennaitambarm from "../../../assets/images/chennaitambarmhair.jpg";
import chennaitambarmskin from "../../../assets/images/chennaitambaramskin.jpg";
import chennaitambaramhomeopathy from "../../../assets/images/chennaitambaramhomeopathy.png";
import chennaitambaramskin1 from "../../../assets/images/chennaitambaramskin1.jpg";
import chennaitambaramskin2 from "../../../assets/images/chennaitambaramskin2.jpg";
import chennaitambarampcos from "../../../assets/images/chennaitambarampcos.jpg";
import chennaitambaramchronic from "../../../assets/images/chennaitambaramchronic.png";
import chennaitambarammentalhealth from "../../../assets/images/chennaitambarammentalhealth.jpg";

import chennaivalasaravakkamhair from "../../../assets/images/chennaivalasaravakkamhair1.jpg";
import chennaivalasaravakkamhair1 from "../../../assets/images/chennaivalasaravakkamhair2.jpg";
import chennaivalasaravakkamhair2 from "../../../assets/images/chennaivalasaravakkamhair3.jpg";
import chennaivalasaravakkamhair3 from "../../../assets/images/chennaivalasaravakkamhair4.jpg";
import chennaivalasaravakkamdental1 from "../../../assets/images/chennaivalasaravakkamdental1.jpg";
import chennaivalasaravakkamdental2 from "../../../assets/images/chennaivalasaravakkamdental4.jpg";
import chennaivalasaravakkamdental3 from "../../../assets/images/chennaivalasaravakkamdental5.jpg";

import hcuraHeroVideo from "../../../assets/video/hcura-hero2.mp4";
import hcuraHeroVideo1 from "../../../assets/video/hcura-hero6.mp4";
import hcuraHeroVideo2 from "../../../assets/video/hcura-hero4.mp4";

const ICON_MAP = {
  "quality-icon": FaAward,
  "personalized-icon": FaUserCheck,
  "affordable-icon": FaCoins,
};

const Icon = ({ name, size = 24, className = "", ariaHidden = true }) => {
  const Comp = ICON_MAP[name];
  if (!Comp) return <span className={className} aria-hidden={ariaHidden} />;
  return <Comp size={size} className={className} aria-hidden={ariaHidden} />;
};

const HCuraChennai = () => {
  const [activeLocation, setActiveLocation] = useState("pondyhcura");
  const [activeService, setActiveService] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isChanging, setIsChanging] = useState(false);
  const sectionRef = useRef(null);
  const servicesRef = useRef(null);

  
  // Auto-scroll state and ref
  const [isAutoScrollPaused, setIsAutoScrollPaused] = useState(false);
  const autoScrollRef = useRef(null);

  // Modal viewer state
  const [valasaravakamchennaiBaModalOpen, setTambaramBaModalOpen] =
    useState(false);
  const [valasaravakamchennaiBaModalItems, setTambaramBaModalItems] = useState(
    []
  );
  const [valasaravakamchennaiBaModalStartIndex, setTambaramBaModalStartIndex] =
    useState(0);

  const whyChooseControls = useAnimation();
  const [whyChooseRef, whyChooseInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Scrolling functions
  const scrollGallery = (direction) => {
    const container = document.getElementById("scrollableGrid");
    const cardWidth = 420;
    const currentScroll = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;

    let newScrollPosition;
    if (direction === "next") {
      newScrollPosition = Math.min(currentScroll + cardWidth, maxScroll);
    } else {
      newScrollPosition = Math.max(currentScroll - cardWidth, 0);
    }

    container.scrollTo({
      left: newScrollPosition,
      behavior: "smooth",
    });

    updateScrollIndicators();
  };

  useEffect(() => {
  const videos = document.querySelectorAll("video");

  videos.forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
  });
}, []);

  const updateScrollIndicators = () => {
    const container = document.getElementById("scrollableGrid");
    const progressBar = document.getElementById("progressBar");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");

    if (!container || !progressBar) return;

    const scrollPercentage =
      (container.scrollLeft / (container.scrollWidth - container.clientWidth)) *
      100;
    progressBar.style.width = `\${scrollPercentage}%`;

    if (prevBtn) prevBtn.disabled = container.scrollLeft <= 0;
    if (nextBtn)
      nextBtn.disabled =
        container.scrollLeft >=
        container.scrollWidth - container.clientWidth - 10;
  };

  useEffect(() => {
    if (valasaravakamchennaiBaModalOpen) {
      const container = document.getElementById("scrollableGrid");
      if (container) {
        container.addEventListener("scroll", updateScrollIndicators);
        updateScrollIndicators();

        const cardWidth = 420;
        container.scrollLeft =
          valasaravakamchennaiBaModalStartIndex * cardWidth;

        return () => {
          container.removeEventListener("scroll", updateScrollIndicators);
        };
      }
    }
  }, [valasaravakamchennaiBaModalOpen, valasaravakamchennaiBaModalStartIndex]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (whyChooseInView) {
      whyChooseControls.start("visible");
    }
  }, [whyChooseControls, whyChooseInView]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Auto-advance effect for services
  useEffect(() => {
    if (autoScrollRef.current) {
      clearInterval(autoScrollRef.current);
      autoScrollRef.current = null;
    }

    if (!isAutoScrollPaused) {
      autoScrollRef.current = setInterval(() => {
        setActiveService((prev) => {
          const next = (prev + 1) % advancedServices.length;
          setIsChanging(true);
          setTimeout(() => {
            setIsChanging(false);
          }, 300);
          return next;
        });
      }, 10000);
    }

    return () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
        autoScrollRef.current = null;
      }
    };
  }, [isAutoScrollPaused]);

// Add this useEffect after your existing useEffect hooks
useEffect(() => {
  document.title = "Best Multispeciality Clinic in Puducherry | H-Cura Hair, Skin, Dental & Homeopathy";
  const metaDescription = document.querySelector("meta[name='description']");
  if (metaDescription) {
    metaDescription.setAttribute(
      "content",
      "H-Cura Multispeciality Clinic in Puducherry offers advanced hair, skin, dental & homeopathy treatments. Expert care for lasting results. Book now!"
    );
  }
  const metaKeywords = document.querySelector("meta[name='keywords']");
  if (metaKeywords) {
    metaKeywords.setAttribute(
      "content",
      "Multispeciality clinic Puducherry, Hair clinic Puducherry, Skin care clinic Puducherry, Homeopathy clinic Puducherry, Dental clinic Puducherry, Advanced hair treatment Puducherry, Hair fall treatment Puducherry, PRP hair therapy Puducherry, GFC hair therapy Puducherry, Exosome hair treatment Puducherry, Skin care treatment Puducherry, Anti-aging treatment Puducherry, HydraFacial Puducherry, Acne treatment Puducherry, Hair growth treatment Puducherry, Cosmetic dermatology Puducherry, Holistic homeopathy Puducherry, Chronic illness homeopathy Puducherry, Allergy treatment Puducherry, Painless dental treatment Puducherry, Dental implants Puducherry, Teeth whitening Puducherry, Orthodontics Puducherry, Oral health Puducherry, Best clinic in Puducherry, H-Cura clinic Puducherry,"
    );
  }
  // Set canonical link
  const existingCanonical = document.querySelector("link[rel='canonical']");
  if (existingCanonical) {
    existingCanonical.setAttribute("href", "https://www.h-cura.com/multispecialty-clinic-in-puducherry/");
  } else {
    const canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    canonicalLink.setAttribute("href", "https://www.h-cura.com/multispecialty-clinic-in-puducherry/");
    document.head.appendChild(canonicalLink);
  }
 
}, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  const locations = {
    pondyhcura: {
      name: "Puducherry",
      address:
        "45 Feet Road, Vellalar St, next to Vairam Fitness,",
      phone: "+91 99646 88333",
      hours: "All day 10 am to 8pm ",
      nearbyAreas: "Lawspet, Muthialpet, Mudaliarpet, Reddiarpalayam",
      popularServices: [
        "PRP Hair Treatment",
        "Dental Fillings & Root Canal",
        "Acne & Skin Problems",
        "Smile Makeover",
      ],
      specialties: "Hair Growth & Dental Care",
      mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Puducherry",
      video: hcuraHeroVideo1,
    },
    valasaravakkam: {
      name: "Gerugambakkam",
      address:
        "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
      phone: "+91 99646 88333",
      hours: "Mon-Sat: 10:00 AM - 8:00 PM, Sun: 10:00 AM - 1:00 PM",
      nearbyAreas: "Porur, Mangadu, Moulivakkam",
      popularServices: [
        "Braces for Teeth",
        "Hair Fall Treatment",
        "Dark Spots Removal",
        "Women's Health Problems",
      ],
      specialties: "Skin Care & Ladies Health",
      mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai",
      video: hcuraHeroVideo1,
    },
    gerugambakkam: {
      name: "Tambaram",
      address:
        "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
      phone: "+91 99646 88333",
      hours: "Mon-Sat: 9:00 AM - 9:00 PM, Sun: 10:00 AM - 3:00 PM",
      nearbyAreas: "Chromepet, Pallavaram, Perungalathur",
      popularServices: [
        "White Patches Treatment",
        "Kids Dental Care",
        "Long Term Health Problems",
      ],
      specialties: "Hair Problems & Health Issues",
      mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai",
      video: hcuraHeroVideo1,
    },
  };

  const advancedServices = [
    {
      id: "hair",
      title: "Hair Treatment in Puducherry – Get Your Hair Back",
      subtitle: "Stop Hair Loss, Get Thick Hair",
      description:
        "Are you worried about hair fall or bald spots? Our hair doctors in Puducherry help people get their hair back. We use safe treatments that really work.",
      image: chennaitambarm,
      treatments: [
        {
          name: "Low Level Laser Therapy Puducherry",
          description:
            "We use safe, low-level laser light to stimulate hair follicles and improve blood circulation in your scalp. This non-invasive treatment helps promote natural hair growth.",
          icon: "laser-therapy-icon",
          image: chennaivalasaravakkamhair,
          benefits: [
            "Stimulates hair follicles",
            "Improves scalp circulation",
            "Non-invasive treatment",
            "No downtime required",
          ],
        },

        {
          name: "GFC Hair Treatment Puducherry",
          description:
            "This is a new way to grow hair. We use special growth factors from your blood to make hair grow faster and thicker.",
          icon: "gfc-icon",
          image: chennaivalasaravakkamhair1,
          benefits: [
            "Hair grows faster",
            "More hair on head",
            "Looks natural",
            "Made just for you",
          ],
        },
        {
          name: "GFC + Dermapen Puducherry",
          description:
            "Advanced hair restoration treatment combining Growth Factor Concentrate (GFC) therapy with Dermapen microneedling to stimulate natural hair growth and improve scalp health for effective hair fall control.",
          icon: "prp-icon",
          image: chennaivalasaravakkamhair2,
          benefits: [
            "Growth factor therapy",
            "Microneedling treatment",
            "Enhanced scalp absorption",
            "Natural hair regeneration",
          ],
        },
      ],
      testimonial: {
        quote:
          "I was losing a lot of hair. After PRP and GFC treatment at H-Cura Puducherry, my hair came back completely. Now I feel confident again.",
        author: "Arjun K.",
        location: "Lawspet",
      },
    },
    {
      id: "skin",
      title: "Skin Treatment in Puducherry – Clear & Glowing Skin",
      subtitle: "Fix Skin Problems, Look Beautiful",
      description:
        "Do you have pimples, dark spots, or dull skin? Our skin doctors in Puducherry help you get clear, glowing skin that makes you look younger.",
      image: chennaitambarmskin,
      treatments: [
        {
          name: "HydraFacial Treatment Puducherry",
          description:
            "This cleans your skin deeply, removes dirt and dead skin, and makes your face glow immediately. No pain, just beautiful skin.",
          icon: "pigmentation-icon",
          image: chennaitambaramskin1,
          benefits: [
            "Cleans skin deeply",
            "Face glows right away",
            "No rest needed",
            "Special creams used",
          ],
        },
        {
          name: "Dark Spots Removal Puducherry",
          description:
            "We remove dark patches, brown spots, and uneven skin color using laser and peeling treatments that are safe and work well.",
          icon: "pigmentation-icon",
          image: chennaitambaramskin2,
          benefits: [
            "Dark spots go away",
            "Skin color becomes even",
            "Skin feels smooth",
            "Results last long",
          ],
        },
        {
          name: "Mole and Birth Mark Removal Puducherry",
          description:
            "We safely remove unwanted moles and birth marks using advanced techniques. Our treatments leave your skin smooth and clear.",
          icon: "pigmentation-icon",
          image: chennaivalasaravakkamhair3,
          benefits: [
            "Safe removal process",
            "Minimal scarring",
            "Quick healing time",
            "Smooth clear skin",
          ],
        },
      ],
      testimonial: {
        quote:
          "I had very bad pimple marks on my face. After HydraFacial at H-Cura Puducherry, my skin became clear and people started complimenting me.",
        author: "Priya M.",
        location: "White Town",
      },
    },
    {
      id: "dental",
      title: "Dental Care in Puducherry – Perfect Teeth & Smile",
      subtitle: "No Pain, Beautiful Smile",
      description:
        "Scared of dentist? Don't worry! Our dental doctors in Puducherry make sure you feel no pain. We fix all teeth problems and give you a beautiful smile.",
      image:
        "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      treatments: [
        {
          name: "Teeth Extraction Puducherry",
          description:
            "We provide safe and painless tooth extraction services using modern techniques. Our experienced dentists ensure comfortable procedures with proper care.",
          icon: "smile-icon",
          image: chennaivalasaravakkamdental1,
          benefits: [
            "Painless procedure",
            "Quick recovery",
            "Expert care",
            "Safe extraction",
          ],
        },

        {
          name: "Composite Filling Treatment Puducherry",
          description:
            "Advanced tooth-colored composite fillings that restore your tooth naturally. Quick, comfortable procedure that preserves your natural tooth structure.",
          icon: "composite-filling-icon",
          image: chennaivalasaravakkamdental2,
          benefits: [
            "Matches natural tooth color",
            "Preserves tooth structure",
            "Quick single visit",
            "Long-lasting durability",
          ],
        },

        {
          name: "Orthodontic Braces Treatment Puducherry",
          description:
            "Professional orthodontic treatment with high-quality metal and ceramic braces. Achieve perfectly aligned teeth with our comprehensive braces solutions.",
          icon: "braces-icon",
          image: chennaivalasaravakkamdental3,
          benefits: [
            "Effective teeth alignment",
            "Durable metal/ceramic options",
            "Proven treatment method",
            "Comprehensive orthodontic care",
          ],
        },
      ],
      testimonial: {
        quote:
          "I was scared of dentist since childhood. But at H-Cura Puducherry, they made me so comfortable. My root canal was completely painless.",
        author: "Vikram S.",
        location: "Muthialpet",
      },
    },
    {
      id: "homeopathy",
      title: "Homeopathy in Puducherry – Natural Medicine for All",
      subtitle: "Natural Healing, No Side Effects",
      description:
        "Tired of taking too many medicines? Our homeopathy doctors in Puducherry treat your health problems naturally without any side effects.",
      image: chennaitambaramhomeopathy,
      treatments: [
        {
          name: "PCOD Treatment in Puducherry",
          description:
            "Many women have PCOD problems like irregular periods, weight gain, hair fall. We treat this naturally and help you feel normal again.",
          icon: "constitutional-icon",
          image: chennaitambarampcos,
          benefits: [
            "Treats main problem",
            "Whole body gets better",
            "Medicine made for you",
            "Long term health",
          ],
        },
        {
          name: "PCOS Treatment in Puducherry",
          description:
            "PCOS makes periods irregular and causes other problems. Our natural treatment helps balance your hormones properly.",
          icon: "hormonal-icon",
          image: chennaitambaramchronic,
          benefits: [
            "Periods become regular",
            "Problems reduce",
            "Hormones get balanced",
            "Helps in pregnancy",
          ],
        },
        {
          name: "Pregnancy Problems Treatment",
          description:
            "Having trouble getting pregnant? We help couples have babies naturally by treating both husband and wife with safe homeopathy medicine.",
          icon: "chronic-icon",
          image: chennaitambarammentalhealth,
          benefits: [
            "Less need for other medicines",
            "Life becomes better",
            "Treats real cause",
            "Safe for everyone",
          ],
        },
      ],
      testimonial: {
        quote:
          "I had PCOS for 5 years and tried many doctors. Only at H-Cura Puducherry, the homeopathy treatment made my periods regular naturally.",
        author: "Divya R.",
        location: "Mudaliarpet",
      },
    },
  ];

  const testimonials = [
    {
      name: "Priya R.",
      location: "Lawspet",
      text: "My hair was falling a lot. The PRP treatment here really worked. Now I have thick hair again and feel happy.",
      rating: 5,
      service: "Hair Treatment",
    },
    {
      name: "Karthik M.",
      location: "White Town",
      text: "I had pimples for many years. The homeopathy treatment here cleared my skin completely. Very good doctors.",
      rating: 5,
      service: "Skin Treatment",
    },
    {
      name: "Divya S.",
      location: "Muthialpet",
      text: "I was scared of root canal but the doctor here made it painless. The clinic is very clean and staff is friendly.",
      rating: 4,
      service: "Dental Care",
    },
  ];

  const features = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Easy to Reach",
      description:
        "Our clinic is right in the heart of Puducherry. People from Lawspet, Muthialpet, and Reddiarpalayam can reach us easily by bus, auto, or car.",
      highlight: "Good Location",
    },
    {
      icon: <FaUserMd />,
      title: "Good Doctors",
      description:
        "All our doctors are well trained and have many years of experience. They know how to treat hair, skin, teeth, and health problems properly.",
      highlight: "Expert Care",
    },
    {
      icon: <GiMedicalPack />,
      title: "New Machines",
      description:
        "We have the latest machines and equipment for PRP hair treatment, laser skin treatment, and computer-guided dental work.",
      highlight: "Modern Equipment",
    },
    {
      icon: <FaHeartbeat />,
      title: "Natural Treatment",
      description:
        "We believe in treating the main cause of your problem, not just the symptoms. We use both modern medicine and natural healing.",
      highlight: "Complete Care",
    },
    {
      icon: <FaAward />,
      title: "Good Results",
      description:
        "Hundreds of patients have gotten better here. Many people give us 5-star reviews and come back to us when they have problems.",
      highlight: "Happy Patients",
    },
    {
      icon: <FaRegLightbulb />,
      title: "Personal Care",
      description:
        "Every patient is different. Our doctors spend time to understand your problem and make a treatment plan just for you.",
      highlight: "Individual Treatment",
    },
    {
      icon: <MdOutlineHealthAndSafety />,
      title: "Very Clean & Safe",
      description:
        "We keep everything very clean and use only approved medicines. Your safety is most important to us during treatment.",
      highlight: "Safe Treatment",
    },
    {
      icon: <MdSupportAgent />,
      title: "Always Help You",
      description:
        "Even after treatment, we check how you are doing. If you have any problem, you can call us anytime for help.",
      highlight: "Ongoing Support",
    },
  ];

  const testimonialQuotes = [
    "The doctors here really listen to your problems and make treatment plans that work.",
    "After trying many places, only H-Cura could solve my skin problems completely.",
    "They care about patients and use natural ways to heal which I really like.",
  ];

  const handleServiceChange = (index) => {
    setIsChanging(true);
    setTimeout(() => {
      setActiveService(index);
      setIsChanging(false);
    }, 300);
  };

  const serviceLearnMoreUrl = (serviceId) => {
    switch (serviceId) {
      case "hair":
        return "/advanced-grow-hair-treatment";
      case "skin":
        return "/advanced-hydrafacial-treatment";
      case "dental":
        return "/dental-treatment";
      case "homeopathy":
        return "/homeopathy-best-treatments/";
      default:
        return "/services";
    }
  };

  const heroBackgroundUrl = tambarambanner3;
  const servicesBackgroundUrl =
    "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80";

  const serviceIconMap = {
    hair: {
      url: tambaramhair,
      bgColor: "rgba(255,154,158,0.12)",
      borderColor: "rgba(255,154,158,0.18)",
      color: "#ff4d6d",
    },
    skin: {
      url: tambaramskin,
      bgColor: "rgba(255,223,121,0.12)",
      borderColor: "rgba(255,223,121,0.18)",
      color: "#ffb400",
    },
    dental: {
      url: "https://img.icons8.com/fluency/48/000000/tooth.png",
      bgColor: "rgba(144,238,144,0.12)",
      borderColor: "rgba(144,238,144,0.18)",
      color: "#28a745",
    },
    homeopathy: {
      url: tambaramleaf,
      bgColor: "rgba(135,206,250,0.12)",
      borderColor: "rgba(135,206,250,0.18)",
      color: "#0099cc",
    },
  };

  const treatmentIconMap = {
    "prp-icon": {
      url: "https://img.icons8.com/fluency/48/000000/syringe.png",
      bgColor: "rgba(255,140,140,0.06)",
      borderColor: "rgba(255,140,140,0.12)",
    },
    "gfc-icon": {
      url: "https://img.icons8.com/fluency/48/000000/biotech.png",
      bgColor: "rgba(170,200,255,0.06)",
      borderColor: "rgba(110,160,255,0.12)",
    },
    "transplant-icon": {
      url: "https://img.icons8.com/fluency/48/000000/hair-care.png",
      bgColor: "rgba(255,230,140,0.06)",
      borderColor: "rgba(255,200,60,0.12)",
    },
    "hydrafacial-icon": {
      url: "https://img.icons8.com/fluency/48/000000/spa-care.png",
      bgColor: "rgba(200,255,230,0.06)",
      borderColor: "rgba(60,200,120,0.12)",
    },
    "pigmentation-icon": {
      url: "https://img.icons8.com/fluency/48/000000/foundation-makeup.png",
      bgColor: "rgba(250,210,255,0.06)",
      borderColor: "rgba(220,120,240,0.12)",
    },
    "antiaging-icon": {
      url: "https://img.icons8.com/fluency/48/000000/collagen.png",
      bgColor: "rgba(220,245,255,0.06)",
      borderColor: "rgba(80,200,240,0.12)",
    },
    "smile-icon": {
      url: "https://img.icons8.com/fluency/48/000000/happy-tooth.png",
      bgColor: "rgba(200,255,220,0.06)",
      borderColor: "rgba(80,200,120,0.12)",
    },
    "rootcanal-icon": {
      url: "https://img.icons8.com/fluency/48/000000/tooth-cleaning.png",
      bgColor: "rgba(255,240,200,0.06)",
      borderColor: "rgba(240,180,60,0.12)",
    },
    "aligner-icon": {
      url: "https://img.icons8.com/fluency/48/000000/braces.png",
      bgColor: "rgba(230,230,255,0.06)",
      borderColor: "rgba(140,120,240,0.12)",
    },
    "constitutional-icon": {
      url: "https://img.icons8.com/fluency/48/000000/holistic-therapy.png",
      borderColor: "rgba(160,160,240,0.12)",
    },
    "hormonal-icon": {
      url: "https://img.icons8.com/fluency/48/000000/hormone.png",
      bgColor: "rgba(255,230,240,0.06)",
      borderColor: "rgba(240,160,200,0.12)",
    },
    "chronic-icon": {
      url: "https://img.icons8.com/fluency/48/000000/medical-pack.png",
      bgColor: "rgba(230,255,240,0.06)",
      borderColor: "rgba(160,240,200,0.12)",
    },
  };

  // SAMPLE gallery (10 per service)
  const SAMPLE_GALLERY = {
    hair: [
      {
        id: "hair-1",
        combined: img1,
        testimonial: {
          quote:
            "I was completely bald. After 6 months of PRP treatment, my hair came back! Amazing!",
          author: "Rajesh K.",
        },
      },
      {
        id: "hair-2",
        combined: img2,
        testimonial: {
          quote:
            "The bald spot on top of my head is now full of hair. PRP and GFC really work!",
          author: "Amit S.",
        },
      },
      {
        id: "hair-3",
        combined: img3,
        testimonial: {
          quote:
            "My hairline was going back. Now it looks like when I was 20 years old!",
          author: "Priya M.",
        },
      },
      {
        id: "hair-4",
        combined: img4,
        testimonial: {
          quote:
            "GFC and QR678 treatment gave me natural hair regrowth. Now I don't worry about hair loss anymore.",
          author: "Karthik R.",
        },
      },

      {
        id: "hair-5",
        combined: img5,
        testimonial: {
          quote:
            "Best decision I made. My hair grew back naturally without any side effects.",
          author: "Deepak V.",
        },
      },
      {
        id: "hair-6",
        combined: img6,
        testimonial: {
          quote:
            "In just 3 months, I could see more hair on my head. Very happy with results.",
          author: "Anitha L.",
        },
      },
      {
        id: "hair-7",
        combined: img7,
        testimonial: {
          quote:
            "From almost bald to full head of hair. Thank you H-Cura doctors!",
          author: "Suresh K.",
        },
      },
      {
        id: "hair-8",
        combined: img8,
        testimonial: {
          quote:
            "My wife is shocked seeing my new hair. Even my friends ask what I did.",
          author: "Vikram P.",
        },
      },
      {
        id: "hair-9",
        combined: img9,
        testimonial: {
          quote:
            "My thin hair became thick again. I look 10 years younger now.",
          author: "Ramesh B.",
        },
      },
      {
        id: "hair-10",
        combined: img10,
        testimonial: {
          quote:
            "After trying many places, only H-Cura could solve my hair problem completely.",
          author: "Mahesh T.",
        },
      },
    ],

    skin: [
      {
        id: "skin-1",
        combined: img11,
        testimonial: {
          quote:
            "Had pimples for years. Now my face is completely clear and glowing!",
          author: "Sneha R.",
        },
      },
      {
        id: "skin-2",
        combined: img12,
        testimonial: {
          quote:
            "HydraFacial removed all my dark spots. My skin glows like a baby now.",
          author: "Kavya M.",
        },
      },
      {
        id: "skin-3",
        combined: img13,
        testimonial: {
          quote:
            "The lines on my face are almost gone. I look much younger now.",
          author: "Meera K.",
        },
      },
      {
        id: "skin-4",
        combined: img14,
        testimonial: {
          quote:
            "My skin color became even all over. No more dark and light patches.",
          author: "Preethi S.",
        },
      },
      {
        id: "skin-5",
        combined: img15,
        testimonial: {
          quote:
            "The brown patches on my face disappeared completely after treatment.",
          author: "Divya L.",
        },
      },
      {
        id: "skin-6",
        combined: img16,
        testimonial: {
          quote:
            "People say I look 5 years younger. My skin is tight and glowing.",
          author: "Anjali P.",
        },
      },
      {
        id: "skin-7",
        combined: img17,
        testimonial: {
          quote:
            "All my old pimple marks are gone. My skin is smooth like silk.",
          author: "Rohit M.",
        },
      },
      {
        id: "skin-8",
        combined: img18,
        testimonial: {
          quote:
            "The dark circles under my eyes are gone. I look fresh and awake.",
          author: "Lakshmi V.",
        },
      },
      {
        id: "skin-9",
        combined: img19,
        testimonial: {
          quote:
            "My loose skin became tight without any surgery. Amazing treatment!",
          author: "Sunita K.",
        },
      },
      {
        id: "skin-10",
        combined: img20,
        testimonial: {
          quote: "My whole face changed. Everyone asks what treatment I took.",
          author: "Ravi S.",
        },
      },
    ],

    dental: [
      {
        id: "dental-1",
        combined:
          "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "They made my smile perfect. Now I smile confidently in photos!",
          author: "Arun K.",
        },
      },
      {
        id: "dental-2",
        combined:
          "https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "My yellow teeth became white in just one visit. Very happy!",
          author: "Priya R.",
        },
      },
      {
        id: "dental-3",
        combined:
          "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "My implant teeth look and feel exactly like my real teeth.",
          author: "Suresh M.",
        },
      },
      {
        id: "dental-4",
        combined:
          "https://images.unsplash.com/photo-1601568544619-9e77545a0c94?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "Clear braces made my teeth straight. Nobody knew I was wearing them.",
          author: "Kavitha S.",
        },
      },
      {
        id: "dental-5",
        combined:
          "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "Root canal was painless. My tooth stopped hurting and is strong now.",
          author: "Ramesh P.",
        },
      },
      {
        id: "dental-6",
        title: "Dental Case 6 - Gum Problem Fixed",
        combined:
          "https://images.unsplash.com/photo-1542736667-069246bdbc6d?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "My gums were bleeding every day. Now they are healthy and pink.",
          author: "Deepa L.",
        },
      },
      {
        id: "dental-7",
        title: "Dental Case 7 - Perfect Tooth Cap",
        combined:
          "https://images.unsplash.com/photo-1579684385127-1ef15d508118?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "The cap on my tooth fits perfectly. It looks exactly like my real tooth.",
          author: "Vikram R.",
        },
      },
      {
        id: "dental-8",
        title: "Dental Case 8 - Complete Smile Change",
        combined:
          "https://images.unsplash.com/photo-1555708982-8645ec6618c7?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "They changed my whole smile. I feel like a new person now.",
          author: "Anitha M.",
        },
      },
      {
        id: "dental-9",
        title: "Dental Case 9 - Kid Not Scared Anymore",
        combined:
          "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "My child was scared of dentist. Now he actually likes coming here.",
          author: "Sita K.",
        },
      },
      {
        id: "dental-10",
        title: "Dental Case 10 - All Teeth Problems Solved",
        combined:
          "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "They fixed all my teeth problems in one go. Life changing treatment!",
          author: "Mahesh V.",
        },
      },
    ],

    homeopathy: [
      {
        id: "homeopathy-1",
        title: "Homeopathy Case 1 - PCOS Problem Solved",
        combined:
          "https://images.unsplash.com/photo-1577003833619-76bbd7f82948?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "My periods became regular naturally. PCOS problem is completely gone now.",
          author: "Divya R.",
        },
      },
      {
        id: "homeopathy-2",
        title: "Homeopathy Case 2 - Long Time Sickness Cured",
        combined:
          "https://images.unsplash.com/photo-1505751171710-1f6d0ace5a85?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "Had health problems for years. Homeopathy cured me without side effects.",
          author: "Raj M.",
        },
      },
      {
        id: "homeopathy-3",
        title: "Homeopathy Case 3 - Got Baby After Treatment",
        combined:
          "https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "Couldn't have baby for 3 years. After homeopathy treatment, got pregnant!",
          author: "Preethi S.",
        },
      },
      {
        id: "homeopathy-4",
        title: "Homeopathy Case 4 - Tension Problem Gone",
        combined:
          "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "Was always worried and tense. Now I feel calm and peaceful.",
          author: "Arjun K.",
        },
      },
      {
        id: "homeopathy-5",
        title: "Homeopathy Case 5 - Stomach Problem Fixed",
        combined:
          "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "My stomach pain and gas problem is completely cured now.",
          author: "Meera L.",
        },
      },
      {
        id: "homeopathy-6",
        title: "Homeopathy Case 6 - Skin Allergy Cured",
        combined:
          "https://images.unsplash.com/photo-1594824111567-8b5d7e0d5ad6?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "Had skin allergy for 10 years. Homeopathy cured it permanently.",
          author: "Sundar R.",
        },
      },
      {
        id: "homeopathy-7",
        title: "Homeopathy Case 7 - Breathing Problem Gone",
        combined:
          "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "Couldn't breathe properly for years. Now I can breathe freely.",
          author: "Lakshmi P.",
        },
      },
      {
        id: "homeopathy-8",
        title: "Homeopathy Case 8 - Joint Pain Relief",
        combined:
          "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "Knee pain was very bad. Homeopathy reduced it without painkillers.",
          author: "Raman V.",
        },
      },
      {
        id: "homeopathy-9",
        title: "Homeopathy Case 9 - Headache Problem Solved",
        combined:
          "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote:
            "Had severe headaches daily. Now I don't get headaches at all.",
          author: "Kavya M.",
        },
      },
      {
        id: "homeopathy-10",
        title: "Homeopathy Case 10 - Overall Health Better",
        combined:
          "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3",
        testimonial: {
          quote: "My whole body health improved. Feel energetic and happy now.",
          author: "Deepak S.",
        },
      },
    ],
  };

  // Autoplay toggle state per thumbnail
  const [thumbnailFlipState, setThumbnailFlipState] = useState({
    hair: Array(10).fill(false),
    skin: Array(10).fill(false),
    dental: Array(10).fill(false),
    homeopathy: Array(10).fill(false),
  });

  useEffect(() => {
    const timers = [];
    Object.keys(SAMPLE_GALLERY).forEach((svcKey) => {
      SAMPLE_GALLERY[svcKey].forEach((_, idx) => {
        const t = setInterval(() => {
          setThumbnailFlipState((prev) => {
            const copy = { ...prev };
            copy[svcKey] = copy[svcKey].slice();
            copy[svcKey][idx] = !copy[svcKey][idx];
            return copy;
          });
        }, 5000 + idx * 250);
        timers.push(t);
      });
    });
    return () => timers.forEach((t) => clearInterval(t));
  }, []);

  const openTambaramBaModal = (serviceKey, startIndex = 0) => {
    setTambaramBaModalItems(SAMPLE_GALLERY[serviceKey]);
    setTambaramBaModalStartIndex(startIndex);
    setTambaramBaModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeTambaramBaModal = () => {
    setTambaramBaModalOpen(false);
    setTambaramBaModalItems([]);
    setTambaramBaModalStartIndex(0);
    document.body.style.overflow = "";
  };

  return (
    <div className="pondyhcura-hcura-chennai">
     

      {/* <section className="pondyhcura-hero" style={{ position: 'relative', overflow: 'hidden' }}>
  <video
    autoPlay
    muted
    loop
    playsInline
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: -2
    }}
  >
    <source src={hcuraHeroVideo} type="video/mp4" />
  </video>

  <div 
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(rgba(41, 33, 33, 0.3), rgba(112, 111, 111, 0.3))',
      zIndex: -1
    }}
  ></div>

  <div className="pondyhcura-hero-content">
    <motion.h1
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="pondyhcura-main-heading"
    >
      H-Cura Clinic Puducherry
    </motion.h1>
    
    <motion.h2
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="pondyhcura-sub-heading"
    >
      Hair, Skin, Teeth & Natural Medicine Treatment
    </motion.h2>
    
    <motion.p
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.4 }}
      className="pondyhcura-hero-description"
    >
      Welcome to H-Cura Clinic in Puducherry – the best place for all your health and beauty needs. 
      We help people with hair fall problems, skin issues, teeth troubles, and health problems using both modern treatment and natural medicine. 
      Our clinic is easy to reach for people from Lawspet, Muthialpet, Reddiarpalayam, and nearby areas. 
      We have good doctors, new machines, and clean facilities to give you the best care.
    </motion.p>
    
    <motion.div
      className="pondyhcura-hero-buttons"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.6 }}
    >
      <Link to="/bookconsultation" className="pondyhcura-primary-button">Book Appointment</Link>
      <a href="https://wa.me/918870001377" className="pondyhcura-secondary-button" target="_blank" rel="noopener noreferrer">
        <FaWhatsapp /> WhatsApp Us
      </a>
    </motion.div>

    <motion.div
      className="pondyhcura-location-buttons"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.65 }}
    >
      <div className="location-header">
        <FaMapMarkerAlt className="location-icon" />
        <span>Find Our Other Clinics</span>
      </div>
      
      <div className="location-nav-buttons">
        <Link to="/homeopathy-clinic-in-gerugambakkam-chennai/" className="location-nav-btn">
          <FaDirections />
          <span>Gerugambakkam</span>
        </Link>
        
        <Link to="/homeopathy-clinic-in-tambaram-chennai/" className="location-nav-btn">
          <FaDirections />
          <span>Tambaram</span>
        </Link>
        
        <Link to="/homeopathy-clinic-in-chennai/" className="location-nav-btn">
          <FaDirections />
          <span>Chennai Main</span>
        </Link>
      </div>
    </motion.div>

    <motion.div
      className="pondyhcura-clinic-location-tabs"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.7 }}
    >
    </motion.div>

    <motion.div
      className="pondyhcura-specialties-row"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.8 }}
    >
    </motion.div>
  </div>
</section> */}

      <section className="tambaram-hcura-hero-section" style={{ position: 'relative', overflow: 'hidden' }}>
        {/* Background Video */}
        <video
          autoPlay
          muted
          loop
          playsInline
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: -2
          }}
        >
         <source src={hcuraHeroVideo} type="video/mp4" />
        </video>
      
        {/* Video Overlay */}
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(rgba(41, 33, 33, 0.3), rgba(112, 111, 111, 0.3))',
            zIndex: -1
          }}
        ></div>
      
        <div className="tambaram-hcura-hero-content-wrapper">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="tambaram-hcura-primary-title"
          >
            H-Cura Multispecialty Clinic Puducherry
          </motion.h1>
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="tambaram-hcura-secondary-title"
          >
            Expert Hair, Skin, Dental & Homeopathy Treatments
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="tambaram-hcura-description-text"
          >
Welcome to H-Cura Clinic, Puducherry, your trusted destination for complete health and beauty care. We provide advanced treatments for hair fall, skin problems, dental care, and general health issues using a combination of modern technology and natural therapies. Our clinic is conveniently located and easily accessible for patients from Lawspet, Muthialpet, Mudaliarpet, Reddiarpalayam, Gorimedu, and surrounding areas. With experienced doctors, advanced equipment, and a hygienic environment, H-Cura ensures safe, effective, and personalized care for every patient.          </motion.p>
          
          <motion.div
            className="tambaram-hcura-action-buttons"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <Link to="/bookconsultation" className="tambaram-hcura-btn-primary">Book Appointment</Link>
            <a href="https://wa.me/918870001377" className="tambaram-hcura-btn-secondary" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> WhatsApp Consult
            </a>
          </motion.div>
      
          {/* <motion.div
            className="tambaram-hcura-location-navigation"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.65 }}
          >
            <div className="tambaram-hcura-location-header">
              <FaMapMarkerAlt className="tambaram-hcura-location-icon" />
              <span className="tambaram-hcura-location-title">Our Chennai Locations</span>
            </div>
            
            <div className="tambaram-hcura-location-buttons">
              <Link to="/multispecialty-clinic-in-gerugambakkam-chennai" className="tambaram-hcura-location-btn">
                <FaDirections />
                <span>Gerugambakkam</span>
              </Link>
              
              <Link to="/multispecialty-clinic-in-tambaram-chennai" className="tambaram-hcura-location-btn">
                <FaDirections />
                <span>Tambaram</span>
              </Link>
              
              <Link to="/multispecialty-clinic-in-chennai/" className="tambaram-hcura-location-btn">
                <FaDirections />
                <span>Back</span>
              </Link>
            </div>
          </motion.div> */}
        </div>
      </section>

      {/* DOCTORS */}
      {/* <section id="doctors" className="pondyhcura-doctors">
        <div className="pondyhcura-section-header">
          <span className="pondyhcura-section-subtitle">Meet Our Good Doctors</span>
          <h2>Our Expert Doctors in Puducherry</h2>
          <div className="pondyhcura-decorative-line"><span className="pondyhcura-decorative-icon"><FaUserMd /></span></div>
          <p className="pondyhcura-section-description">Our doctors have many years of experience and know how to treat hair, skin, teeth, and health problems properly. They care about patients and use the best treatment methods.</p>
        </div>

        <div className="pondyhcura-doctors-grid">
          {[
            { name: "Dr. A. Ramesh", title: "Skin Doctor", qualifications: "MD (Skin), Beauty Treatment", experience: "12 years", image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?q=80&w=800&auto=format&fit=crop", specialties: ["Pimples & Dark Spots", "Laser Treatment"], alt: "Dr. A. Ramesh - Skin specialist at H-Cura Puducherry who treats pimples and dark spots" },
            { name: "Dr. S. Priya", title: "Hair Doctor", qualifications: "DNB (Skin), Hair Expert", experience: "10 years", image: "https://images.unsplash.com/photo-1550831107-1553da8c8464?q=80&w=800&auto=format&fit=crop", specialties: ["PRP & GFC",], alt: "Dr. S. Priya - Hair specialist at H-Cura Puducherry who does PRP and gfc" },
            { name: "Dr. K. Vinod", title: "Teeth Doctor", qualifications: "MDS (Teeth)", experience: "9 years", image: "https://images.unsplash.com/photo-1580281657521-1d5f5b61f4a7?q=80&w=800&auto=format&fit=crop", specialties: ["New Teeth", "Root Canal"], alt: "Dr. K. Vinod - Teeth doctor at H-Cura Puducherry who does implants and root canal" },
                        { name: "Dr. N. Shalini", title: "Natural Medicine Doctor", qualifications: "BHMS", experience: "15 years", image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=800&auto=format&fit=crop", specialties: ["PCOS/PCOD", "Long Term Health"], alt: "Dr. N. Shalini - Natural medicine doctor at H-Cura Puducherry who treats PCOS and health problems" }
          ].map((doc, i) => (
            <motion.article key={i} className="pondyhcura-doctor-card" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.12 }} aria-labelledby={`doctor-${i}-name`}>
              <div className="pondyhcura-doctor-media" style={{ backgroundImage: `url('${doc.image}')` }} role="img" aria-label={doc.alt} />
              <div className="pondyhcura-doctor-body">
                <h3 id={`doctor-${i}-name`}>{doc.name}</h3>
                <p className="pondyhcura-doctor-title">{doc.title} • {doc.qualifications}</p>
                <p className="pondyhcura-doctor-exp">{doc.experience} experience</p>
                <ul className="pondyhcura-doctor-specialties">{doc.specialties.map((s, si) => <li key={si}><FaCheckCircle className="pondyhcura-doctor-check" /> {s}</li>)}</ul>
                <div className="pondyhcura-doctor-cta">
                  <Link to="/bookconsultation" className="pondyhcura-doctor-book">Meet {doc.name.split(' ')[1]}</Link>
                  <a href={`https://wa.me/918870001377?text=Hi%20I%20want%20to%20meet%20${encodeURIComponent(doc.name)}`} className="pondyhcura-doctor-whatsapp" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> WhatsApp</a>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </section> */}

      {/* BEFORE & AFTER - Clean Single Images Only */}
      {/* <section id="before-after" className="pondyhcura-before-after">
        <div className="pondyhcura-section-header">
          <span className="pondyhcura-section-subtitle">Real Patient Results</span>
          <h2>Before & After Treatment Photos</h2>
          <div className="pondyhcura-decorative-line"><span className="pondyhcura-decorative-icon"><FaArrowRight /></span></div>
          <p className="pondyhcura-section-description">These are real photos of our patients from Puducherry clinic. You can see how they looked before treatment and how much better they look after treatment.</p>
        </div>

        <div className="pondyhcura-before-tabs">
          {['hair','skin','dental','homeopathy'].map((s, idx) => (
            <button key={s} className={`pondyhcura-ba-tab ${activeService === idx ? 'active' : ''}`} onClick={() => { handleServiceChange(idx); setIsAutoScrollPaused(true); setTimeout(()=>setIsAutoScrollPaused(false),10000); }} aria-pressed={activeService === idx}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>

        <div className="pondyhcura-before-carousel-wrapper">
          <div className="pondyhcura-before-carousel" role="list" aria-label="Before after gallery">
            {(() => {
              const svcKey = activeService === 0 ? 'hair' : activeService === 1 ? 'skin' : activeService === 2 ? 'dental' : 'homeopathy';
              const items = SAMPLE_GALLERY[svcKey] || [];
              
              return items.map((item, idx) => (
                <article key={item.id} className="pondyhcura-ba-clean-card" role="listitem">
                  <div className="pondyhcura-ba-clean-container">
                    <div className="pondyhcura-ba-clean-image-wrapper">
                      <img 
                        src={item.combined} 
                        alt={`${item.title} before and after treatment at H-Cura Puducherry`} 
                        className="pondyhcura-ba-clean-image"
                        title={`${item.title} - Real patient results at H-Cura Puducherry clinic`}
                      />
                      <div className="pondyhcura-ba-clean-title">
                        <h4>{item.title}</h4>
                      </div>
                    </div>
                    <div className="pondyhcura-ba-clean-actions">
                      <button 
                        className="pondyhcura-ba-clean-view-btn" 
                        onClick={() => openTambaramBaModal(svcKey, idx)}
                      >
                        See More Photos
                      </button>
                    </div>
                  </div>
                </article>
              ));
            })()}
          </div>
        </div>
      </section> */}
      <section id="before-after" className="pondyhcura-before-after">
        <div className="pondyhcura-section-header">
          <span className="pondyhcura-section-subtitle">
            Real Patient Results
          </span>
          <h2>Before & After Treatment Photos</h2>
          <div className="pondyhcura-decorative-line">
            <span className="pondyhcura-decorative-icon">
              <FaArrowRight />
            </span>
          </div>
          <p className="pondyhcura-section-description">
            These are real photos of our patients from Puducherry clinic.
            You can see how they looked before treatment and how much better
            they look after treatment.
          </p>
        </div>

        <div className="pondyhcura-before-tabs">
          {["hair", "skin"].map((s, idx) => (
            <button
              key={s}
              className={`pondyhcura-ba-tab ${
                activeService === idx ? "active" : ""
              }`}
              onClick={() => {
                handleServiceChange(idx);
                setIsAutoScrollPaused(true);
                setTimeout(() => setIsAutoScrollPaused(false), 10000);
              }}
              aria-pressed={activeService === idx}
            >
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>

        <div className="pondyhcura-before-carousel-wrapper">
          <div
            className="pondyhcura-before-carousel"
            role="list"
            aria-label="Before after gallery"
          >
            {(() => {
              const svcKey = activeService === 0 ? "hair" : "skin";
              const items = SAMPLE_GALLERY[svcKey] || [];

              return items.map((item, idx) => (
                <article
                  key={item.id}
                  className="pondyhcura-ba-clean-card"
                  role="listitem"
                >
                  <div className="pondyhcura-ba-clean-container">
                    <div className="pondyhcura-ba-clean-image-wrapper">
                      <img
                        src={item.combined}
                        alt={`${item.title} before and after treatment at H-Cura Puducherry`}
                        className="pondyhcura-ba-clean-image"
                        title={`${item.title} - Real patient results at H-Cura Puducherry clinic`}
                      />
                      <div className="pondyhcura-ba-clean-title">
                        <h4>{item.title}</h4>
                      </div>
                    </div>
                    <div className="pondyhcura-ba-clean-actions">
                      <button
                        className="pondyhcura-ba-clean-view-btn"
                        onClick={() => openTambaramBaModal(svcKey, idx)}
                      >
                        See More Photos
                      </button>
                    </div>
                  </div>
                </article>
              ));
            })()}
          </div>
        </div>
      </section>

      {/* Modal viewer for detailed view with scrolling */}
      {valasaravakamchennaiBaModalOpen && (
        <div
          className="pondyhcura-ba-modal"
          role="dialog"
          aria-modal="true"
          aria-label="Before and after detailed gallery"
        >
          <div
            className="pondyhcura-ba-modal-backdrop"
            onClick={closeTambaramBaModal}
          />
          <div className="pondyhcura-ba-modal-panel">
            <header className="pondyhcura-ba-modal-header">
              <h3>Treatment Results - H-Cura Puducherry</h3>
              <button
                className="pondyhcura-ba-modal-close"
                onClick={closeTambaramBaModal}
                aria-label="Close photos"
              >
                ×
              </button>
            </header>

            <div className="pondyhcura-ba-modal-body">
              <div className="pondyhcura-ba-scrollable-container">
                <div
                  className="pondyhcura-ba-scroll-track"
                  id="scrollTrack"
                >
                  <div
                    className="pondyhcura-ba-scrollable-grid"
                    id="scrollableGrid"
                  >
                    {valasaravakamchennaiBaModalItems.map((item, index) => (
                      <div
                        key={item.id}
                        className="pondyhcura-ba-scrollable-card"
                        data-index={index}
                      >
                        <div className="pondyhcura-ba-scrollable-image-container">
                          <img
                            src={item.combined}
                            alt={`${item.title} complete before after results at H-Cura Puducherry`}
                            className="pondyhcura-ba-scrollable-image"
                            title={`${item.title} - Patient transformation at H-Cura Puducherry`}
                          />
                        </div>
                        <div className="pondyhcura-ba-scrollable-content">
                          <h4>{item.title}</h4>
                          <p className="pondyhcura-ba-scrollable-testimonial">
                            "{item.testimonial?.quote || ""}"
                          </p>
                          <div className="pondyhcura-ba-scrollable-author">
                            — {item.testimonial?.author || ""}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Scroll Progress Bar */}
                <div className="pondyhcura-ba-scroll-progress">
                  <div
                    className="pondyhcura-ba-progress-bar"
                    id="progressBar"
                  ></div>
                </div>
              </div>

              {/* Enhanced Navigation Controls */}
              <div className="pondyhcura-ba-enhanced-controls">
                <div className="pondyhcura-ba-nav-buttons">
                  <button
                    className="pondyhcura-ba-nav-btn pondyhcura-ba-prev-btn"
                    id="prevBtn"
                    onClick={() => scrollGallery("prev")}
                    aria-label="Previous photos"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                    </svg>
                    Previous
                  </button>

                  <button
                    className="pondyhcura-ba-nav-btn pondyhcura-ba-next-btn"
                    id="nextBtn"
                    onClick={() => scrollGallery("next")}
                    aria-label="Next photos"
                  >
                    Next
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* WHY CHOOSE */}
      <section
        id="why-choose"
        className="pondyhcura-why-choose-enhanced"
      >
        <div className="pondyhcura-curved-background">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,160C672,203,768,245,864,229.3C960,213,1056,139,1152,117.3C1248,96,1344,128,1392,144L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg>
        </div>

        <div className="pondyhcura-content-wrapper">
          <motion.div
  className="pondyhcura-section-header"
  initial={{ opacity: 0, y: 30 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.8 }}
>
  <span className="pondyhcura-section-subtitle">
    Best Healthcare
  </span>

  <h2>Why Choose H-Cura Clinic in Puducherry?</h2>

  <div className="pondyhcura-decorative-line">
    <span className="pondyhcura-decorative-icon">
      <FaShieldAlt />
    </span>
  </div>

  <p className="pondyhcura-section-description">
    Your health and beauty are important to us. At H-Cura Puducherry, we have experienced doctors, advanced equipment, and a patient-friendly environment. Whether you need treatment for hair fall, skin problems, dental care, or natural therapies for health issues, we make sure you receive safe and effective treatment. Our clinic is easy to reach for people from Lawspet, Muthialpet, Mudaliarpet, Reddiarpalayam, Gorimedu, and surrounding areas. We focus on your comfort and provide the best care with lasting results.
  </p>
</motion.div>


          <div className="pondyhcura-awards-banner">
            <div className="pondyhcura-award">
              <FaStar className="pondyhcura-award-icon" />
              <span>Best Clinic 2024</span>
            </div>
            <div className="pondyhcura-award">
              <FaCertificate className="pondyhcura-award-icon" />
              <span>Quality Certificate</span>
            </div>
            <div className="pondyhcura-award">
              <FaAward className="pondyhcura-award-icon" />
              <span>Top Healthcare</span>
            </div>
          </div>

          <motion.div
            className="pondyhcura-features-grid"
            ref={whyChooseRef}
            variants={containerVariants}
            initial="hidden"
            animate={whyChooseControls}
          >
            {features.map((feature, index) => (
              <motion.div
                className="pondyhcura-feature-card-enhanced"
                key={index}
                variants={itemVariants}
              >
                <div className="pondyhcura-feature-header">
                  <div className="pondyhcura-icon-container">
                    {feature.icon}
                    <div className="pondyhcura-icon-glow"></div>
                  </div>
                  <span className="pondyhcura-feature-highlight">
                    {feature.highlight}
                  </span>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                <div className="pondyhcura-feature-footer">
                  <div className="pondyhcura-feature-dots">
                    <span className="pondyhcura-dot"></span>
                    <span className="pondyhcura-dot"></span>
                    <span className="pondyhcura-dot"></span>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>

          <div className="pondyhcura-testimonial-strip">
            <div className="pondyhcura-testimonial-background"></div>
            <div className="pondyhcura-testimonial-content">
              <div className="pondyhcura-quote-marks">"</div>
              <div className="pondyhcura-testimonial-slider">
                {testimonialQuotes.map((quote, index) => (
                  <div
                    className="pondyhcura-testimonial-quote"
                    key={index}
                  >
                    <p>{quote}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="pondyhcura-stats-container">
            <div className="pondyhcura-stat-box">
              <div className="pondyhcura-stat-number">15+</div>
              <div className="pondyhcura-stat-label">
                Years Experience
              </div>
            </div>
            <div className="pondyhcura-stat-box">
              <div className="pondyhcura-stat-number">30+</div>
              <div className="pondyhcura-stat-label">
                Good Doctors
              </div>
            </div>
            <div className="pondyhcura-stat-box">
              <div className="pondyhcura-stat-number">10k+</div>
              <div className="pondyhcura-stat-label">
                Happy Patients
              </div>
            </div>
            <div className="pondyhcura-stat-box">
              <div className="pondyhcura-stat-number">95%</div>
              <div className="pondyhcura-stat-label">
                Success Rate
              </div>
            </div>
          </div>

          <div className="pondyhcura-cta-container">
            <h3>Come to H-Cura Puducherry</h3>
            <p>
              Join thousands of happy patients who got better with our care.
            </p>
            <Link
              to="/bookconsultation"
              className="pondyhcura-cta-button"
            >
              Book Your Visit
            </Link>
          </div>
        </div>

        <div className="pondyhcura-curved-background-bottom">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,160L48,181.3C96,203,192,245,288,229.3C384,213,480,139,576,128C672,117,768,171,864,197.3C960,224,1056,224,1152,213.3C1248,203,1344,181,1392,170.7L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
            ></path>
          </svg>
        </div>
      </section>

      <section
        id="services"
        className="pondyhcura-services-premium-section"
        ref={sectionRef}
      >
        <div
          className={`pondyhcura-services-background ${
            isVisible ? "visible" : ""
          }`}
          style={{
            backgroundImage: `linear-gradient(to right, rgba(255,255,255,0.97), rgba(255,255,255,0.8)), url('${servicesBackgroundUrl}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            opacity: isVisible ? 1 : 0,
          }}
        ></div>

        <div className="pondyhcura-services-container">
          <div
            className={`pondyhcura-services-header ${
              isVisible ? "visible" : ""
            }`}
          >
            <span className="pondyhcura-services-subtitle">
              Best Healthcare
            </span>
            <h2>Our Treatments at H-Cura Puducherry</h2>
            <div className="pondyhcura-services-separator">
              <span></span>
              <div className="pondyhcura-separator-icon"></div>
              <span></span>
            </div>
            <p className="pondyhcura-services-description">
              We give you the best treatment with care and good results. Our
              treatments use both new machines and natural healing methods.
            </p>
          </div>

          <div
            className={`pondyhcura-services-tabs ${
              isVisible ? "visible" : ""
            }`}
            ref={servicesRef}
            onMouseEnter={() => setIsAutoScrollPaused(true)}
            onMouseLeave={() => setIsAutoScrollPaused(false)}
            onFocus={() => setIsAutoScrollPaused(true)}
            onBlur={() => setIsAutoScrollPaused(false)}
          >
            {advancedServices.map((service, index) => {
              const sIcon = serviceIconMap[service.id] || null;
              const isActive = activeService === index;
              return (
                <button
                  key={service.id}
                  className={`pondyhcura-service-tab ${
                    isActive ? "active" : ""
                  }`}
                  onClick={() => {
                    setIsAutoScrollPaused(true);
                    handleServiceChange(index);
                    setTimeout(() => setIsAutoScrollPaused(false), 10000);
                  }}
                >
                  <span
                    className={`pondyhcura-tab-icon pondyhcura-${service.id}-icon bright-icon`}
                    style={{
                      backgroundImage: sIcon
                        ? `url('${sIcon.url}')`
                        : undefined,
                      backgroundSize: "60% auto",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundColor: sIcon ? sIcon.bgColor : undefined,
                      border: sIcon
                        ? `2px solid ${sIcon.borderColor}`
                        : undefined,
                      width: "44px",
                      height: "44px",
                      borderRadius: "12px",
                      display: "inline-block",
                    }}
                  ></span>
                  <span className="pondyhcura-tab-text">
                    {service.title.split(" ")[0]}
                  </span>
                  {isActive && (
                    <span className="pondyhcura-progress-bar"></span>
                  )}
                </button>
              );
            })}
          </div>

          <div className="pondyhcura-tab-indicators">
            {advancedServices.map((service, index) => (
              <span
                key={`indicator-${index}`}
                className={`pondyhcura-tab-indicator ${
                  activeService === index ? "active" : ""
                }`}
                onClick={() => {
                  setIsAutoScrollPaused(true);
                  handleServiceChange(index);
                  setTimeout(() => setIsAutoScrollPaused(false), 10000);
                }}
              ></span>
            ))}
          </div>

          <div
            className={`pondyhcura-service-content-wrapper ${
              isVisible ? "visible" : ""
            }`}
          >
            <div
              className={`pondyhcura-service-main-content ${
                isChanging ? "changing" : ""
              }`}
            >
              <div className="pondyhcura-service-info">
                <h3>{advancedServices[activeService].title}</h3>
                <h4>{advancedServices[activeService].subtitle}</h4>
                <p>{advancedServices[activeService].description}</p>

                <div className="pondyhcura-service-cta">
                  <Link
                    to="/bookconsultation"
                    className="pondyhcura-service-btn"
                  >
                    Meet Doctor
                  </Link>
                  <Link
                    to={serviceLearnMoreUrl(advancedServices[activeService].id)}
                    className="pondyhcura-service-link"
                  >
                    Know More{" "}
                    <span className="pondyhcura-arrow-icon">→</span>
                  </Link>
                </div>
              </div>

              <div className="pondyhcura-service-image-container">
                <div className="pondyhcura-service-image-wrapper">
                  <img
                    src={advancedServices[activeService].image}
                    alt={`${advancedServices[activeService].title} treatment at H-Cura Puducherry`}
                    className="pondyhcura-service-main-image"
                    title={`${advancedServices[activeService].title} - Best treatment at H-Cura Puducherry`}
                  />
                  <div className="pondyhcura-image-overlay"></div>
                  <div className="pondyhcura-service-badge">
                    <span>Best Care</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="pondyhcura-service-treatments">
              <h4>Special Treatments</h4>
              <div className="pondyhcura-treatments-slider">
                {advancedServices[activeService].treatments.map(
                  (treatment, tIndex) => {
                    const tIcon = treatmentIconMap[treatment.icon] || null;
                    return (
                      <div
                        className="pondyhcura-treatment-card"
                        key={tIndex}
                      >
                        <div className="pondyhcura-treatment-image">
                          <img
                            src={treatment.image}
                            alt={`${treatment.name} treatment at H-Cura Puducherry`}
                            title={`${treatment.name} - Special treatment at H-Cura Puducherry`}
                          />
                        </div>
                        <div className="pondyhcura-treatment-content">
                          <div
                            className={`pondyhcura-treatment-icon pondyhcura-${treatment.icon} bright-treatment-icon`}
                            style={{
                              backgroundImage: tIcon
                                ? `url('${tIcon.url}')`
                                : undefined,
                              backgroundSize: "60% auto",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                              backgroundColor: tIcon
                                ? tIcon.bgColor
                                : undefined,
                              border: tIcon
                                ? `2px solid ${tIcon.borderColor}`
                                : undefined,
                              width: "56px",
                              height: "56px",
                              borderRadius: "12px",
                            }}
                          ></div>
                          <h5>{treatment.name}</h5>
                          <p>{treatment.description}</p>
                          <div className="pondyhcura-treatment-benefits">
                            <h6>Good Points:</h6>
                            <ul>
                              {treatment.benefits.map((benefit, i) => (
                                <li key={i}>
                                  <span className="pondyhcura-benefit-icon">
                                    ✓
                                  </span>
                                  {benefit}
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div className="pondyhcura-treatment-cta">
                            <Link
                              className="pondyhcura-treatment-learnmore"
                              to={serviceLearnMoreUrl(
                                advancedServices[activeService].id
                              )}
                            >
                              Know More
                            </Link>
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>

            <div className="pondyhcura-service-testimonial">
              <div className="pondyhcura-testimonial-content">
                <div className="pondyhcura-quote-icon">"</div>
                <p>{advancedServices[activeService].testimonial.quote}</p>
                <div className="pondyhcura-testimonial-author">
                  <strong>
                    {advancedServices[activeService].testimonial.author}
                  </strong>{" "}
                  | {advancedServices[activeService].testimonial.location}
                </div>
              </div>
              <div className="pondyhcura-testimonial-decoration"></div>
            </div>

            <div className="pondyhcura-service-stats">
              <div className="pondyhcura-stat-item">
                <div className="pondyhcura-stat-number">
                  98<span>%</span>
                </div>
                <div className="pondyhcura-stat-label">
                  Happy Patients
                </div>
              </div>
              <div className="pondyhcura-stat-item">
                <div className="pondyhcura-stat-number">
                  5000<span>+</span>
                </div>
                <div className="pondyhcura-stat-label">
                  Good Results
                </div>
              </div>
              <div className="pondyhcura-stat-item">
                <div className="pondyhcura-stat-number">
                  15<span>+</span>
                </div>
                <div className="pondyhcura-stat-label">
                  Years Experience
                </div>
              </div>
              <div className="pondyhcura-stat-item">
                <div className="pondyhcura-stat-number">
                  12<span>+</span>
                </div>
                <div className="pondyhcura-stat-label">
                  Expert Doctors
                </div>
              </div>
            </div>

            <div className="pondyhcura-service-features">
              <div className="pondyhcura-feature">
                <div
                  className="pondyhcura-feature-icon pondyhcura-quality-icon"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  aria-hidden
                >
                  <Icon name="quality-icon" size={28} />
                </div>
                <h5>Best Quality</h5>
                <p>Good treatment and new machines</p>
              </div>

              <div className="pondyhcura-feature">
                <div
                  className="pondyhcura-feature-icon pondyhcura-personalized-icon"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  aria-hidden
                >
                  <Icon name="personalized-icon" size={28} />
                </div>
                <h5>Personal Care</h5>
                <p>Treatment made just for you</p>
              </div>

              <div className="pondyhcura-feature">
                <div
                  className="pondyhcura-feature-icon pondyhcura-affordable-icon"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  aria-hidden
                >
                  <Icon name="affordable-icon" size={28} />
                </div>
                <h5>Good Price</h5>
                <p>Best care at fair cost</p>
              </div>
            </div>

            <div className="pondyhcura-service-action">
              <h4>Ready to Get Better?</h4>
              <p>Start your journey to better health and beauty today.</p>
              <div className="pondyhcura-action-buttons">
                <Link
                  to="/bookconsultation"
                  className="pondyhcura-primary-action-btn"
                >
                  Book Appointment
                </Link>
                <Link
                  to="/contact-us/"
                  className="pondyhcura-secondary-action-btn"
                >
                  Call Us
                </Link>
              </div>
            </div>

            <div
              className={`pondyhcura-services-partners \${isVisible ? 'visible' : ''}`}
            >
              <h4>Our Machine Partners</h4>
              <div className="pondyhcura-partners-logos">
                <div
                  className="pondyhcura-partner-logo"
                  style={{ backgroundImage: "", backgroundSize: "80% 80%" }}
                ></div>
                <div
                  className="pondyhcura-partner-logo"
                  style={{ backgroundImage: "", backgroundSize: "80% 80%" }}
                ></div>
                <div
                  className="pondyhcura-partner-logo"
                  style={{ backgroundImage: "", backgroundSize: "80% 80%" }}
                ></div>
                <div
                  className="pondyhcura-partner-logo"
                  style={{ backgroundImage: "", backgroundSize: "80% 80%" }}
                ></div>
                <div
                  className="pondyhcura-partner-logo"
                  style={{ backgroundImage: "", backgroundSize: "80% 80%" }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pondyhcura-stats-banner">
        <div className="pondyhcura-stat">
          <h3>10,000+</h3>
          <p>Happy Patients</p>
        </div>
        <div className="pondyhcura-stat">
          <h3>15+</h3>
          <p>Years Experience</p>
        </div>
        <div className="pondyhcura-stat">
          <h3>30+</h3>
          <p>Good Doctors</p>
        </div>
        <div className="pondyhcura-stat">
          <h3>3</h3>
          <p>Easy Locations</p>
        </div>
      </section>

      <section id="locations" className="pondyhcura-locations">
  <div className="pondyhcura-section-header">
    <h2>Our Clinic Locations</h2>
    <p>Find the nearest H-Cura clinic for your health needs</p>
  </div>

  <div className="pondyhcura-location-tabs">
    <Link
      to="/multispecialty-clinic-in-puducherry"
      className={`pondyhcura-location-tab ${
        activeLocation === "pondyhcura" ? "active" : ""
      }`}
    >
      <FaMapMarkerAlt /> Puducherry
    </Link>
{/*     
    <Link
      to="/multispecialty-clinic-in-gerugambakkam-chennai"
      className={`pondyhcura-location-tab ${
        activeLocation === "valasaravakkam" ? "active" : "" // Assuming 'valasaravakkam' is the key for Gerugambakkam in this context
      }`}
    >
      <FaMapMarkerAlt /> Gerugambakkam
    </Link>
    
    <Link
      to="/multispecialty-clinic-in-tambaram-chennai/"
      className={`pondyhcura-location-tab ${
        activeLocation === "gerugambakkam" ? "active" : "" // Assuming 'gerugambakkam' is the key for Tambaram in this context
      }`}
    >
      <FaMapMarkerAlt /> Tambaram
    </Link> */}
  </div>

  <div className="pondyhcura-location-details">
    <div className="pondyhcura-location-card">
      <div className="pondyhcura-location-header">
        <h3>{locations[activeLocation].name} Clinic</h3>
        <span className="pondyhcura-specialty-tag">
          {locations[activeLocation].specialties}
        </span>
      </div>

      <div className="pondyhcura-location-grid">
        <div className="pondyhcura-location-info">
          <div className="pondyhcura-info-item">
            <FaMapMarkerAlt className="pondyhcura-info-icon" />
            <div>
              <h4>Address</h4>
              <p>{locations[activeLocation].address}</p>
              <p>
                <small>
                  Near: {locations[activeLocation].nearbyAreas}
                </small>
              </p>
            </div>
          </div>

          <div className="pondyhcura-info-item">
            <FaPhone className="pondyhcura-info-icon" />
            <div>
              <h4>Phone</h4>
              <p>{locations[activeLocation].phone}</p>
              <button
                className="pondyhcura-contact-button"
                onClick={() =>
                  (window.location.href = `tel:${locations[
                    activeLocation
                  ].phone.replace(/\s+/g, "")}`)
                }
              >
                Call Now
              </button>
            </div>
          </div>

          <div className="pondyhcura-info-item">
            <FaClock className="pondyhcura-info-icon" />
            <div>
              <h4>Open Hours</h4>
              <p>{locations[activeLocation].hours}</p>
            </div>
          </div>
        </div>

        <div className="pondyhcura-popular-services">
          <h4>Popular Treatments at {locations[activeLocation].name}</h4>
          <ul>
            {locations[activeLocation].popularServices.map(
              (service, index) => (
                <li key={index}>
                  <FaCheckCircle className="pondyhcura-check-icon" />
                  {service}
                </li>
              )
            )}
          </ul>
          <a
            href={locations[activeLocation].mapUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="pondyhcura-map-link"
          >
            See on Map <FaArrowRight />
          </a>
        </div>
      </div>
    </div>

    <div className="pondyhcura-location-image">
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "12px",
        }}
      >
        <source src={locations[activeLocation].video} type="video/mp4" />
      </video>
    </div>
  </div>
</section>



      <section id="testimonials" className="pondyhcura-testimonials">
        <div className="pondyhcura-section-header">
          <h2>What Our Patients Say</h2>
          <p>Real words from our happy patients at H-Cura Puducherry</p>
        </div>
        <div className="pondyhcura-testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              className="pondyhcura-testimonial-card"
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <div className="pondyhcura-testimonial-rating">
                {[...Array(5)].map((_, i) => (
                  <FaStar
                    key={i}
                    className={
                      i < testimonial.rating
                        ? "pondyhcura-star-filled"
                        : "pondyhcura-star-empty"
                    }
                  />
                ))}
              </div>
              <p className="pondyhcura-testimonial-text">
                "{testimonial.text}"
              </p>
              <div className="pondyhcura-testimonial-author">
                <div
                  className="pondyhcura-author-info"
                  title={`${testimonial.name} • ${testimonial.location} • ${testimonial.service}`}
                >
                  <h4 className="pondyhcura-testimonial-name">
                    {testimonial.name}
                  </h4>
                  <p className="pondyhcura-testimonial-meta">
                    {testimonial.location} • {testimonial.service}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <section
        id="appointment"
        className="pondyhcura-appointment"
        style={{
          position: "relative",
          overflow: "hidden",
          color: "#fff",
        }}
      >
        {/* Background Video */}
        <video
          autoPlay
          muted
          loop
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -2,
          }}
        >
          <source src={hcuraHeroVideo2} type="video/mp4" />
        </video>

        {/* Video Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65))",
            zIndex: -1,
          }}
        ></div>

        <div
          className="pondyhcura-appointment-content"
          role="region"
          aria-labelledby="appointment-heading"
        >
          <motion.h2
            id="appointment-heading"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            Book Your Visit at H-Cura Puducherry Today
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Take the first step to better health and beauty. Come visit H-Cura
            Clinic in Puducherry.
          </motion.p>

          <motion.div
            className="pondyhcura-contact-options"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <div className="pondyhcura-contact-option">
              <FaPhone /> <span>+91 99646 88333  </span>
            </div>
            <div className="pondyhcura-contact-option">
              <FaGlobe />{" "}
              <a
                href="https://h-cura.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.h-cura.com
              </a>
            </div>
          </motion.div>

          <motion.div
            className="pondyhcura-appointment-buttons"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
          >
            <Link
              to="/bookconsultation"
              className="pondyhcura-primary-button"
            >
              Book Appointment
            </Link>
            <a
              href="https://wa.me/919964688333"
              className="pondyhcura-whatsapp-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp /> WhatsApp Us
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default HCuraChennai;
